




























































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins, Watch } from 'vue-property-decorator';

@Component
export default class EmailProviderModal extends Mixins(ModalMixin) {
  form!: CrsForm<'emails', 'createProvider' | 'updateProvider'>;

  @Watch('mode', { immediate: true })
  switchForm(mode: 'create' | 'update') {
    const formMode = mode === 'create' ? 'createProvider' : 'updateProvider';
    this.form = this.$crsForm('emails', formMode, {
      name: '',
      imap: {
        host: '',
        port: 993,
        secure: true,
      },
      smtp: {
        host: '',
        port: 465,
        secure: true,
      },
    });
  }

  async getForm() {
    return compass.do('emails', 'findOneProvider', { params: { providerId: this.id } });
  }
}
